import React from 'react';

import type { TooltipProps } from '@mui/material';
import { Typography } from '@mui/material';
import { AlineTooltip } from 'src/components/generic';
import { InfoIcon } from 'src/components/icons/InfoIcon';
import { openLink } from 'src/helpers';
import { alineLinkStylesWithUnderline } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<Pick<WhatsThisProps, 'hintUrl'>>()((theme, { hintUrl }) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  hintText: (() => {
    if (hintUrl)
      return {
        ...alineLinkStylesWithUnderline,
        fontSize: 12,
      };

    return {
      color: theme.palette.primary.main,
      fontSize: 12,
    };
  })(),
}));

interface WhatsThisProps {
  tooltipMsg: string;
  hintText?: string;
  hintTextPosition?: 'left' | 'right';
  hintUrl?: string;
  tooltipPlacement?: TooltipProps['placement'];
}

export function WhatsThis({
  hintText = "What's this?",
  hintTextPosition = 'right',
  hintUrl,
  tooltipMsg,
  tooltipPlacement = 'top',
}: WhatsThisProps): JSX.Element {
  const { classes } = useStyles({ hintUrl });
  const children = [
    <InfoIcon key={0} />,
    <Typography
      key={1}
      className={classes.hintText}
      onClick={() => {
        if (hintUrl) openLink(hintUrl);
      }}
    >
      {hintText}
    </Typography>,
  ];

  return (
    <AlineTooltip arrow placement={tooltipPlacement} title={tooltipMsg}>
      <div className={classes.container}>
        {hintTextPosition === 'right' ? children : children.reverse()}
      </div>
    </AlineTooltip>
  );
}
